import React from 'react';
import { Service } from "../types";

export const ServiceData: Service[] = [
    {
        content: (
            <>
                <div className='card-title'>Технический проект</div>

                <ul className='list-group'>
                    <li className='list-group-item'>Стилевое решение пространства - мудборд</li>
                    <li className='list-group-item'>Рабочая документация (чертежи) для реализации проекта</li>
                    <li className='list-group-item'>Выезд на обмер помещения обсуждается отдельно</li>
                </ul>
                <hr />
                <div className='card-text' style={{ display: "flex", flexDirection: "column" }}>
                    <span>Срок выполнения:</span>
                    <span>15-20 рабочих дней</span>
                </div>
                <hr />
                <div className='card-text'>
                    <ul>
                        <li>от 1500 ₽/м2</li>
                    </ul>
                </div>
            </>
        ),
    },
    {
        content: (
            <>
                <div className='card-title'>Полный дизайн проект</div>

                <ul className='list-group'>
                    <li className='list-group-item'>3Д Визуализации всех комнат</li>
                    <li className='list-group-item'>Рабочая документация (чертежи) для реализации проекта</li>
                    <li className='list-group-item'>Подбор наполнения помещений</li>
                </ul>
                <hr />
                <div className='card-text' style={{ display: "flex", flexDirection: "column" }}>
                    <span>Срок выполнения:</span>
                    <span>60-90 рабочих дней</span>
                </div>
                <hr />
                <div className='card-text'> 
                    <ul>
                        <li>менее 70 м2- 4500 ₽/м2</li>
                        <li>71-100 м2- 4000 ₽/м2</li>
                        <li>101-200 м2- 3500 ₽/м2</li>
                        <li>более 200 м2- по запросу </li>
                    </ul>
                </div>
            </>
        )
    },
    {
        content: (
            <>
                <div className='card-title'>Проект-апгрейд</div>
                <ul className='list-group'>
                    <li className='list-group-item'>Для квартир с отделкой от застройщика</li>
                </ul>
                <hr />
                <div className='card-text' style={{ display: "flex", flexDirection: "column" }}>
                    <span>Срок выполнения:</span>
                    <span>30 рабочих дней</span>
                </div>
                <hr />
                <div className='card-text'>
                    <ul>
                        <li>менее 50 м2- 150 000 ₽ за услугу</li>
                        <li>более 51 м2- по запросу</li>
                    </ul>
                </div>
            </>
        )
    },
    {
        content: (
            <>
                <div className='card-title'>Консультация</div>
                <div>
                    <ul className='list-group'>
                        <li className='list-group-item'>Онлайн (без выезда): первая
                            консультация
                            15 000 руб., каждая следующая + 10
                            000 р.</li>
                        <li className='list-group-item'>С выездом: цена такая же, как
                            онлайн + дополнительно
                            оплачивается выезд
                            (5000 руб./1 шт.)</li>
                    </ul>
                </div>
            </>
        )
    }
];